/*
 * Module for the Correspondence Packet Review status tab.
 */
rs.module("content/participant/correspondencepacketreview/distributiontab",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        //
        // Initialize the module
        //
        function initialize(jsSelectors, distributionMethods, userDefaults) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var distributionMethodSelect = criteria.js(jsSelectors.distributionMethodSelect, { required: false });
            var emailContainer = criteria.js(jsSelectors.emailContainer, { required: false });
            var emailAddress = criteria.js(jsSelectors.emailAddress, { required: false });
            var ccEmailAddress = criteria.js(jsSelectors.ccEmailAddress, { required: false });
            var emailSubject = criteria.js(jsSelectors.emailSubject, { required: false });
            var emailBody = criteria.js(jsSelectors.emailBody, { required: false });

            var printContainer = criteria.js(jsSelectors.printContainer, { required: false });
            var printerSelect = criteria.js(jsSelectors.printerSelect, { required: false });

            // All containers have js disabled if packet is cancelled.
            if (distributionMethodSelect) { 

                // Get select helper(s) for working with select lists
                var printerSelectHelper = selectHelper.getHelper(printerSelect);

                // Handle the send method change event
                distributionMethodSelect.change(function () {
                    visibility.hide(emailContainer);
                    visibility.hide(printContainer);

                    // Clear fields and errors
                    [
                        emailAddress,
                        ccEmailAddress,
                        emailSubject,
                        emailBody
                    ].forEach((input) => input.clearErrors().val(''));

                    var selectedDistributionMethod = distributionMethodSelect.val();

                    if ((selectedDistributionMethod & distributionMethods.defaultMethod) == distributionMethods.defaultDistribution) {
                        emailAddress.prop('disabled', true);

                        if ((selectedDistributionMethod & distributionMethods.email) == distributionMethods.email) {
                            emailAddress.val(userDefaults.defaultEmail);
                        }
                        else if ((selectedDistributionMethod & distributionMethods.print) == distributionMethods.print) {
                            printerSelectHelper.setValue(userDefaults.defaultPrinter);
                        }

                        visibility.setVisible(emailContainer, (selectedDistributionMethod & distributionMethods.email) == distributionMethods.email);
                        visibility.setVisible(printContainer, (selectedDistributionMethod & distributionMethods.print) == distributionMethods.print);
                    }
                    else {
                        emailAddress.prop('disabled', false);

                        visibility.setVisible(emailContainer, (selectedDistributionMethod & distributionMethods.email) == distributionMethods.email);
                        visibility.setVisible(printContainer, (selectedDistributionMethod & distributionMethods.print) == distributionMethods.print);
                    }
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);